export default {
    "主页": "主页",
    "作品": "作品",
    "文章": "文章",
    "看单": "看单",
    "喜欢": "喜欢",
    "简介": "简介",
    "招聘职位": "招聘职位",
    "千万": "千万",
    "万": "万",
    "千亿": "千亿",
    "亿": "亿",
    "万亿": "万亿",
    "千万亿": "千万亿",
    "创建的看单": "创建的看单",
    "什么是看单": "什么是看单",
    "新建看单": "新建看单",
    "编辑信息": "编辑信息",
    "删除": "删除",
    "展开全部": "展开全部",
    "收起": "收起",
    "收藏的看单": "收藏的看单",
    "此看单已被设置为私密": "此看单已被设置为私密",
    "此看单已被删除": "此看单已被删除",
    "此看单不存在": "此看单不存在",
    "取消收藏": "取消收藏",
    "文章": "文章",
    "活动": "活动",
    "当前看单审核不通过": "当前看单审核不通过",
    "编辑": "编辑",
    "创建者": "创建者",
    "个视频": "个视频",
    "私密": "私密",
    "公开": "公开",
    "播放全部": "播放全部",
    "该看单暂无内容": "该看单暂无内容",
    "暂无收藏的文章": "暂无收藏的文章",
    "暂无收藏的活动": "暂无收藏的活动",
    "编辑看单信息": "编辑看单信息",
    "看单名称": "看单名称",
    "是否公开": "是否公开",
    "取消": "取消",
    "确定": "确定",
    "删除看单": "删除看单",
    "是否删除该看单？": "是否删除该看单？",
    "是否取消收藏该看单？": "是否取消收藏该看单？",
    "否": "否",
    "是": "是",
    "名称不能为空！": "名称不能为空！",
    "请输入名称": "请输入名称",
    "共": "共",
    "篇文章": "篇文章",
    "个活动": "个活动",
    "是否取消收藏该视频？": "是否取消收藏该视频？",
    "该看单还没有收藏视频！": "该看单还没有收藏视频！",
    "请至少选择一个看单！": "请至少选择一个看单！",
    "拖拽可调整排序": "拖拽可调整排序",
    "移动到": "移动到",
    "移动到看单": "移动到看单",
    "还没有创建的看单": "还没有创建的看单",
    "还没有收藏的看单": "还没有收藏的看单",
    "创作者": "创作者",
    "取消收藏此看单": "取消收藏此看单",
    "收藏此看单": "收藏此看单",
    "返回首页": "返回首页",
    "此看单暂无内容": "此看单暂无内容",
    "收藏到看单": "收藏到看单",
    "取消收藏成功！": "取消收藏成功！",
    "看单主页": "看单主页",
    "更新": "{time} 更新",
    "已收藏": "已收藏",
    "推荐看单": "推荐看单",
    "更新收藏成功！": "更新收藏成功！"
    
}


// WEBPACK FOOTER //
// ./src/languages/cn/collect.js